import { useEffect, useState } from 'react';
import { notification, Table, Pagination, Empty } from "antd";
import { getDeviceContents } from "@axios/api.device";
import { useTranslation } from "react-i18next";

interface propsModel {
    id: string,
}

const { Column } = Table;

export const DeviceDetailContents = (props: propsModel) => {
    const { id } = props;
    const [data, setData] = useState<any>();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);

    const { t } = useTranslation();

    useEffect(() => { if (id) { getData() } }, []);

    const getData = (index = pageIndex, size = pageSize) => {
        getDeviceContents(id, { pageIndex: index, pageSize: size }).then(
            (res) => {
                const { dataList, pageIndex, pageSize, totalCount } = res;
                if (dataList.length > 0) {
                    dataList.map((item: any, itemIndex: number) => {
                        item["index"] = itemIndex;
                        return item;
                    })
                }
                setData(dataList);
                setPageIndex(pageIndex);
                setPageSize(pageSize);
                setTotalCount(totalCount);
            },
            () => { notification.error({ message: t("获取数据失败") }) },
        )
    }

    return (
        <>
            <Table 
                dataSource={data} 
                pagination={false} 
                rowKey="index"
                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
            >
                <Column title={t("来源")} key="source" dataIndex="source"></Column>
                <Column title={t("状态")} key="state" dataIndex="state"></Column>
                <Column title={t("文档标题")} key="title" dataIndex="title"></Column>
                {/* <Column title={t("文档内容")} key="persistentID" dataIndex="persistentID"></Column> */}
            </Table>
            <Pagination
                style={{textAlign: 'right', marginTop: '20px'}}
                current={pageIndex}
                pageSize={pageSize}
                total={totalCount}
                showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}${t("条")}`}
                onChange={(page, pageSize) => { getData(page, pageSize) }}
                onShowSizeChange={(current, size) => { getData(current, size) }}
            ></Pagination>
        </>
    )
}

